import { Input } from "@frui.ts/bootstrap";
import DatePickerBox from "controls/datePickerBox/datePickerBox";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { Col, Form } from "react-bootstrap";
import PersonViewModel from "viewModels/notice/components/personViewModel";

const PersonInput: FunctionComponent<{
  vm: PersonViewModel;
  fullNamePredicate?: boolean;
  fullNameValidationAction?: () => void;
  birthDatePredicate?: boolean;
  birthDateValidationAction?: () => void;
  showBirthdate?: boolean;
}> = observer(
  ({ vm, fullNamePredicate, fullNameValidationAction, birthDatePredicate, birthDateValidationAction, showBirthdate }) => {
    const ta = (code: string) => vm.translateAttribute("individual", code);
    const errorLocalization = (code: string) => {
      if (["min", "max"].includes(code)) {
        return vm.translateAttribute("birthdate", code);
      } else if (code === "invalidDateFormat") {
        return vm.translateGeneral(code);
      } else {
        return code;
      }
    };
    const fromMonth = new Date(new Date().getFullYear() - 100, 0);
    const toMonth = new Date(new Date().getFullYear() - 18, new Date().getMonth());

    const datePickerLocalization = vm.datePickerLocalization;
    datePickerLocalization.strings.todayButton = undefined;

    return (
      <Form.Row>
        <Form.Group controlId="full-name-input" as={Col} sm={12} xl={showBirthdate ? 6 : 12}>
          <Form.Label>{ta("fullName")}</Form.Label>
          <Input target={vm.person} property="fullName" />
        </Form.Group>
        {showBirthdate && (
          <Form.Group controlId="date-of-birth-input" as={Col} sm={12} xl={6}>
            <Form.Label>{ta("birthdate")}</Form.Label>
            <DatePickerBox
              id="date-of-birth-input"
              ignoreTime={true}
              fromMonth={fromMonth}
              toMonth={toMonth}
              month={toMonth}
              errorLocalization={errorLocalization}
              target={vm.person}
              property="birthDate"
              placeholder={vm.translateGeneral("datepicker.placeholder")}
              datePickerLocalization={datePickerLocalization}
              useEndBoundaryAsDefault={true}
            />
          </Form.Group>
        )}
      </Form.Row>
    );
  }
);

export default PersonInput;
